import { useEffect, useState } from 'react'
import RegisterForm from './RegisterForm'
import UserForm from './UserForm'
import RegisterProvider from '../../context/RegisterContext'
import { useLocation } from 'react-router-dom'
import useLogout from '../../hooks/useLogout'
import useIsAuthenticated from 'react-auth-kit/hooks/useIsAuthenticated'
import { AppConfig } from '../../models/shared'
import UtilitiesService from '../../services/UtilitiesService'
import { CircularProgress } from '@mui/material'
import CustomPaper from '../../containers/Paper'

const RegisterPage = () => {
    const [next, setNext] = useState<boolean>(false)
    const { state } = useLocation()
    const logout = useLogout()
    const isAuthenticated = useIsAuthenticated()
    const [config, setConfig] = useState<AppConfig | null>()

    useEffect(() => {
        if (isAuthenticated) logout()
    }, [logout, isAuthenticated])

    useEffect(() => {
        new UtilitiesService().getAppConfig().then((response) => {
            if (response.status !== 200) return
            setConfig(response.data === '' ? null : response.data)
        })
    }, [])

    return (
        <RegisterProvider>
            {config !== undefined ? (
                config !== null ? (
                    !next ? (
                        <RegisterForm
                            handleContinue={() => setNext(true)}
                            linkedInUser={state?.linkedInUser}
                        />
                    ) : (
                        <UserForm linkedInUser={state?.linkedInUser} />
                    )
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <CustomPaper className="w-fit flex flex-col gap-4">
                            <span className="text-3xl font-semibold text-primary">
                                Lo sentimos, registro deshabilitado
                            </span>
                            <span className="text-2xl text-secondary">
                                En este momento no se encuentra disponible el registro de nuevos
                                usuarios.
                            </span>
                            <span className="text-xl text-secondary">
                                Intentá más tarde o contactá a un administrador en caso de que esto
                                continúe.
                            </span>
                        </CustomPaper>
                    </div>
                )
            ) : (
                <div className="w-full h-full flex items-center justify-center">
                    <CircularProgress
                        className="m-2 md:m-5 text-primary"
                        size={64}
                    />
                </div>
            )}
        </RegisterProvider>
    )
}

export default RegisterPage
